import React from 'react';
import clsx from 'clsx';
import { Dropdown } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { states } from '@/constants/lifecycle';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';
import Fetch from '../hooks/fetch';

const listItems = ({ views }) => views.map((view) => ({
  key: `request_view_item_${view.code}`,
  text: view.name,
  value: view.code,
}));

const TaskViewsDropdown = ({
  category,
  className,
  clearable,
  disabled,
  fluid,
  placeholder = 'tasks.views.select.placeholder',
  size = 'large',
  view,
}) => {
  const intl = useIntl();
  const state = Selectors.useTaskViewsDropdown({ category });
  Fetch.useFetchRequestTaskViews({ category }, state.readStatus);
  const onChange = Events.useUpdateTasksViewFilter(category);

  return (
    <>
      <Dropdown
        className={clsx('aridhia-task-views-dropdown', 'max-content', className)}
        clearable={clearable}
        disabled={disabled}
        fluid={fluid}
        id="view_dropdown"
        loading={state.readStatus === states.PENDING}
        onChange={(e, { value }) => onChange({ view: value })}
        options={listItems(state)}
        placeholder={intl.formatMessage({ id: placeholder })}
        search
        selection
        size={size}
        value={view}
      />
    </>
  );
};

export default TaskViewsDropdown;
